import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABELS = {
  founder_ceo: "Founder / CEO",
  ops_manager: "Operations Manager",
  admin: "Administrator",
  supervisor: "Supervisor",
  cleaner: "Cleaner",
  customer: "Customer",
};

export const STAFF_ROLES = ["founder_ceo", "ops_manager", "admin", "supervisor"];
export const MANAGEMENT_ROLES = ["founder_ceo", "ops_manager", "admin"];

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
